import { render, staticRenderFns } from "./pageContainer.vue?vue&type=template&id=2bdc193d&scoped=true"
import script from "./pageContainer.vue?vue&type=script&lang=js"
export * from "./pageContainer.vue?vue&type=script&lang=js"
import style0 from "./pageContainer.vue?vue&type=style&index=0&id=2bdc193d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdc193d",
  null
  
)

export default component.exports